<template>
  <div>
    <div>
      <DateSelector
        ref="dateSelect"
        v-if="!isMeeting"
        v-model="value.date"
        :label="theme"
        segmentType="flight"
        :minDate="minDate"
        :maxDate="maxDate"
        :focusedDate="focusedDate"
        :dateIndex="dateIndex"
        :placeholder="placeholder"
        @setDateRange="(range) => $emit('setDateRange', range)"
        @input="(value) => $emit('setDate', value)"
      />
      <DateSelectorMeetings
        v-if="isMeeting"
        v-model="value.date"
        :minDate="minDate"
        :maxDate="maxDate"
        :label="theme"
        @input="meetingInput"
        :type="type"
      />
    </div>
    <div class="is-flex selectTimeContainer">
      <b-select
        placeholder="Select a time"
        @input="updateTod"
        v-model="value.advanced.tod"
        size="is-small"
        class="customSelect"
        data-test="time_selector"
      >
        <option
          v-for="option in times"
          :value="option.format"
          :key="option.mil"
        >
          {{ option.format }}
        </option>
      </b-select>

      <div
        v-if="showSummary && value.advanced.tod === 'Custom'"
        class="mb-0 pb-0 ml-2 mt-2 is-size-6 customTimeSelector"
        style="line-height: 0.6rem"
      >
        <div v-if="value.advanced.time" >
          <span class="is-size-7 has-text-weight-light mb-0 pb-0">{{
            value.advanced.isDeparture ? "Departs at" : "Lands at"
          }}</span>
          <br />
          {{
            timeHours !== 0
              ? timeHours > 12
                ? timeHours - 12
                : timeHours
              : 12
          }}:{{ timeMinutes }} {{ timeHours > 12 ? "PM" : "AM" }}
          <sup class="is-size-7 has-text-weight-light mb-5">
            +/- {{ value.advanced.hours }}
          </sup>
          <b-icon
            size="is-small"
            :icon="
              value.advanced.occurs === 'arrival'
                ? 'airplane-landing'
                : 'airplane-takeoff'
            "
          />
          <br />
          <div
            class="is-size-7 mt-0 pt-0 is-clickable is-underlined"
            @click="showAdvanced"
          >
            Edit
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelector from "../../DateComponents/DateSelector.vue";
import DateSelectorMeetings from "../../DateComponents/DateSelectorMeetings";
import meetingsMixin from "../../../mixins/meetingsMixin";
import bookingMixin from "../../../mixins/bookingMixin";

export default {
  name: "FlightDateTimeSelector",
  mixins: [meetingsMixin, bookingMixin],
  components: {
    DateSelector,
    DateSelectorMeetings,
  },
  props: {
    theme: {
      type: String,
      default: () => {
        return "";
      },
    },
    type: {
      type: String,
      default: "departure",

    },
    placeholder: {
      type: String,
      default: () => {
        return "";
      },
    },
    value: {
      type: Object,
    },
    dateIndex: Number,
    showSummary: {
      type: Boolean,
      default: true,
    },
    advanced: {
      type: Boolean,
      default: false,
    },
    // TODO Test if those are being passed to DateSelectorMeetings?
    minDate: {
      type: Date,
      default: () => new Date()
    },
    maxDate: {
      type: Date,
      default: () => null
    },
    focusedDate: {
      type: Date,
      default: () => new Date()
    },
  },
  data() {
    return {

    };
  },
  computed: {
    parsedTime() {
      const t = this.value?.advanced?.time;
      return t ? new Date(t) : null;
    },
    timeHours() {
      return this.parsedTime?.getHours();
    },
    timeMinutes() {
      let mins = this.parsedTime?.getMinutes();
      if (mins == "0") {
        return "00";
      } else {
        return mins;
      }
    },
  },
  methods: {
    toggle() {
      this.$refs.dateSelect.toggle();
    },
    updateTod(value) {
      if (value === "Custom") {
        this.$emit("showAdvanced");
      } else {
        //
      }
    },
    showAdvanced() {
      this.$emit("showAdvanced");
    },

    meetingInput(value) {
      this.value.date = value;
      this.$emit("meetingInput", this.value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
